import { useContext } from 'react';
import { AppSettingsContext } from '../contexts';

export const useAppSettings = () => {
  return useContext(AppSettingsContext);
};
